export const sdkInfo = {
    host: 'npmjs.com',
    version: '12.0.2',
    name: '@kontent-ai/delivery-sdk'
};
//# sourceMappingURL=sdk-info.generated.js.map